(function($) {
  'use strict';

  jQuery(document).ready(function($) {

    /*START MENU*/

    var offset = 220; // Kéo xuống khoảng cách 220px thì xuất hiện button
    var duration = 500; // THời gian di trượt là 0.5 giây 
    jQuery(window).scroll(function() {
      if (jQuery(this).scrollTop() > offset) {
        $(".enable-fixed").addClass('menu-fixed');
      } else {
        $(".enable-fixed").removeClass('menu-fixed');
      }
    });

    /*END MENU*/
    
    /*currency*/
    function convert_currency(value){
      var newCurrency = Currency.currentCurrency;
      var oldCurrency = shopCurrency;
      if(isNaN(value)){
        value =  0.0;
      }

      var cents = 0.0;
      var oldFormat = Currency.moneyFormats['USD'][ Currency.format] || '';
                                            var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
                                            if (oldFormat.indexOf('amount_no_decimals') !== -1) {
                                              cents = Currency.convert(parseInt(value, 10)*100, oldCurrency, newCurrency);
                                            }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt(value, 10)/10, oldCurrency, newCurrency);
      }
      else { 
        cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
      }
      var my_data =  Currency.formatMoney(cents, newFormat);
      return my_data;
      
      
    }
    /* end currency */

    function show_dropdown_cart(){

      $.ajax({
        url: ' /cart.js',
        type: 'GET', 
        dataType: 'json',
        success: function(data) {
          $("#cartCount").text(data.item_count);
          if (data.item_count > 0) {
            var html = '';
            html = html + '<div class="mcart-border">';
            html = html + '<ul class="cart-list">';
            $.each(data.items, function(index, el) {
              html = html + '<li id="item-'+el.id+'"> <a class="product-image" href="'+el.url+'"> <img src="' + el.image + '" alt="'+el.title+'"/><span class="quantity">'+el.quantity+'</span></a>';
              html = html + '<div class="product-details"> <a  data-id="'+el.id+'" class="remove small-cart-remove" title="Remove this item"> <i class="fa fa-times-circle"></i> </a>';
              html = html + '<a class="product-name" href="'+el.url+'"> ' + el.title + ' </a>';
              html = html + '<span class="quantity"> <span class="money">'+ convert_currency(el.price) +'</span> </span> </span>' + ' </div></li>';
            });
            html = html + '</ul><p class="total">Subtotal<span id="cartCost"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(data.price,'11')+'">'+convert_currency(data.price,'11')+'</span></span></p>';
            html = html + '<p class="buttons"><a href="/cart" class="btn_cart">View Cart</a><a href="/checkout" class="btn_checkout">Check Out</a></p>';
            html = html + '<div>';

            $(".mini-cart-inner").html(html);

          }else{
            var html = '';
            html = html + ' <div class="mini_cart_arrow"></div>';
            html = html + '<ul class="cart_empty "><li>You have no items in your shopping cart</li>';
            html = html + '<li class="total">Subtotal: <span class="amount"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(data.price,'11')+'">'+convert_currency(data.price,'11')+'</span></span></li>';
            html = html + ' </ul>';
            $(".mini-cart-inner").html(html);
          }

          $("#cartCost").html('<span class="money">'+convert_currency(data.total_price )+'</span>');
        }
      });
    }


    /*START WISHLIST*/

    $(".added-wishlist").hide();
    $(document).on('click',".wishlist", function(event) {
      var $this = $(this);
      event.preventDefault();
      /* Act on the event */
      var myid = $(this).data('form');
      var args = $("input[value='" + myid + "']").first().parent('form').serialize();
      $("#loading").show();
      $.ajax({
        url: '/contact',
        type: 'POST',
        dataType: 'html',
        data: args,
        success: function(data, status) {
          if (status == "success") {
            $this.hide(600);
            $this.parent().children(".added-wishlist").show(700);
            $("#loading").hide(500);
            swal("Success!", "Added success to wishlist!", "success");
          } else {
            $("#loading").hide(500);
            sweetAlert("Oops...", "Please login to use wishlist!", "error");
          }
        }
      });
    });
    $(document).on('click',".wishlist-login", function(event) {
      event.preventDefault();
      /* Act on the event */
      swal({
        title: "Oops...",
        text: "Please login to use wishlist!",
        type: "warning",
        confirmButtonText: "Login",
        timer: 5000,
        showCancelButton: true
      },
           function() {
        window.location.href = 'https://' + Shopify.shop + '/account/login'
      });
    });

    $("#addtocart-message").hide('slow');      
    $(document).on('click',".wishlist-addtocart", function(event) {
      event.preventDefault();
      /* Add product in wishlist to cart*/
      var $this = $(this);
      $("#loading").show();
      var value = $(this).data('wid');
      $('.product-select').val(value);
      var args = $('.add-variant').serialize();
      $.ajax({
        url: $('.add-variant').attr('action'),
        type: 'POST',
        dataType: 'html',
        data: args,
        success: function(data, status) {
          show_dropdown_cart();
          $("#addtocart-message").show('slow');
          var xx = $this.data('title');
          $("."+value).hide();
          $("#title-addtocart").text(xx); 
          if (status == "success") {
            $this.hide(600).next('.wishlist-addedtocart').removeClass('wishlist-addedtocart').show(700);
            $("#loading").hide(500);

          } else {
            $("#loading").hide(500);
            sweetAlert("Oops...", "An error occurred when add to cart!", "error");
          }
        }
      });
    });

    $('.wishlist-remove').on('click', function(event) {
      event.preventDefault();
      $("#loading").show();
      /* Remove product from wishlist*/
      var $this = $(this);
      var value = $(this).data('wid');
      $('.remove-value').val(value);
      var args = $('.contact-form').serialize();
      $.ajax({
        url: $('.contact-form').attr('action'),
        type: 'POST',
        dataType: 'html',
        data: args,
        success: function(data, status) {
          if (status == "success") {
            $("tr." + value).slideUp(600);
            $("#loading").hide(500);
            swal({
              title: "Auto close alert!",
              text: "Remove success.",
              timer: 2000,
              showConfirmButton: false
            });
          } else {
            $("#loading").hide(500);
          }
        }
      });
    });

    /*END WISHLIST*/

    /* Compare Product*/
    var storage = $.localStorage;
    var compare = {};
    var total_compare = 8;
    if (storage.isSet('compare')) {
      compare = storage.get('compare');
    } else {
      storage.set('compare', {});
    }
    function compare_to_table(data) {
      if (Object.keys(data).length <= 0) {
        return '';
      }
      var html = '';
      var i = 0;

      var end_check = (Object.keys(data).length - 1);
      var width_tr = (end_check > 0) ? (90 / (Object.keys(data).length)) : 90;
      var data_html = '';
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        data_html = data_html + '<th class=" ' + el.handle + '"><button type="button" class="close remove-compare center-block" aria-label="Close" data-handle="' + el.handle + '">Remove<span aria-hidden="true" class="remove-compare-x">&times;</span></button></th>';
        //Start title 
        if (i == 0) {
          html = html + '<tr >';
          html = html + '<th width="15%" class="product-name" > Product name </th>';
        }
        html = html + '<td width="' + width_tr + '%"  class="' + el.handle + '"> ' + el.title + '  </td>';
        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End Title 
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > Product image </th>';

        }
        // start product image
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + '"> <img src="' + el.featured_image + '"  width="150"/> ' + '<div class="product-price"> ';
        if (is_sale) {
          html = html + '<strong>On Sale</strong>' + '<span class="price-sale"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(el.price,'11')+'">'+convert_currency(el.price,'11')+'</span></span>';
        } else {
          html = html + '<span class="price-sale"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(el.price,'11')+'">'+convert_currency(el.price,'11')+'</span></span>';
        }
        if (convert_currency(el.compare_at_price, 'nosymbol') > 0) {
          html = html + '<span class="visually-hidden">Regular price</span> <s>' + convert_currency(el.compare_at_price, '11') + '</s>';
        }
        html = html + '</div>';
        //convert_currency(el.price,'3');
        if (el.variants.length > 1) {
          html = html + '<a href="#" onclick="location.href=\'/products/' + el.handle + '\'">Select Options</a>';
        } else {
          html = html + '<a href="#" title="Add to Cart" data-pid="' + el.variants[0].id + '" class="add-to-cart">Add to Cart</a>';
        }
        html = html + ' </td>';

        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End product image
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > Product description </th>';

        }
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + ' "> <p class="description-compare"> ' + el.description + ' </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > AVAILABILITY </th>';

        }

        var avai_stock = (el.available) ? 'Available In stock' : 'Unavailable In stock';
        html = html + '<td   width="' + width_tr + '%" class="available-stock ' + el.handle + '"> <p> ' + avai_stock + ' </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      $(".th-compare").html('<td>Action</td>'+data_html);
      $("#table-compare").html(html);
    }
    function modal_compare(){
      if (!$.isEmptyObject(compare)) {
        // $(".error-compare").hide(20);
        var list_id = '';
        var json_compare = [];
        var check_end = 0;
        var compare_size = (Object.keys(compare).length - 1);
        $.each(compare, function(index, el) {
          var json_url = "/products/" + el + ".js";
          if ($.trim(el) != "") {
            jQuery.getJSON(json_url, function(product) {
              json_compare[check_end] = product;
              if (check_end >= compare_size) {
                compare_to_table(json_compare);
              }
              check_end += 1;
            });

          }

        });
        $("#moda-compare").modal('show');
      }

    }
    $(document).on('click','.compare', function(event) {

      event.preventDefault();
      $("#loading").show();
      /* Act on the event */
      var $this = $(this);
      var pid = $(this).data('pid');

      compare = storage.get('compare');

      if ($.isEmptyObject(compare)) {
        compare = {};
      }
      var check_compare = true;
      if (Object.keys(compare).length >= total_compare) {
        swal({
          title: "info",
          text: "Product Added over 8 product !. Do you want to compare 8 added product ?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4cae4c",
          confirmButtonText: "Yes,I want view it!",
          timer: 3000,
          cancelButtonText: "Continue",
          closeOnConfirm: true
        },
             function() {
          
               modal_compare(compare);
            
        });
      } else {
        for (var i = 1; i <= 8; i++) {
          if (compare['p' + i] == "" || compare['p' + i] == undefined) {
            compare['p' + i] = pid;
            break;
          } else if (compare['p' + i] == pid) {
            $this.addClass('added');
            check_compare = false;
            modal_compare(compare);

            break;
          }
        }
        if (check_compare) {
          storage.set('compare', compare);
          modal_compare(compare);
          $this.addClass('add-success');
          $("[data-pid='"+pid+"']").addClass('added').text('Added to compare');
        }
      }
      $("#loading").hide(500);
    });

    $(document).on('click', '.remove-compare', function(event) {
      event.preventDefault();
      /* Act on the event */

      var id = $(this).data('handle');
      $("." + id).fadeOut(600).remove();
      $("[data-pid='"+id+"']").removeClass('added add-success').text('add to compare');
      $.each(compare, function(index, el) {
        if (el == id) {
          compare[index] = "";
          delete compare[index];
        }
      });
      storage.set('compare', compare);
     
    });

    /** End compare */


    /** Bx slider
    */

    var zoom_config = {
      cursor: 'pointer',
      galleryActiveClass: 'active',
      imageCrossfade: true,
      loadingIcon: "//cdn.shopify.com/s/global/lightbox/v2/loading.gif",
      zoomWindowFadeIn: 500,
      zoomLensFadeIn: 500,
      zoomWindowWidth: 411,
      zoomWindowHeight: 274,
      zoomWindowOffetx: 10,
      scrollZoom: true,
      responsive: true
    };
    var bx_slider;
    var bx_page;

    bx_slider = $('.bxslider').bxSlider( {
      pagerCustom: '#bx-pager',
      controls:false,
      onSlideBefore:function($slideElement, oldIndex, newIndex){
        if(!isNaN(oldIndex) || !isNaN(newIndex)){

          return;

        }
      },
      onSlideAfter: function($slideElement, oldIndex, newIndex) {
        var ni = parseInt( newIndex + 2);
        console.log(ni);

        if(!isNaN(ni)){
          $('.zoomContainer').remove();
          $.removeData($(".bxslider li img"), 'elevateZoom');

          $(".bxslider li:nth-of-type(" + ni + ") img").elevateZoom(zoom_config);
        }

      }

    });
    var bxx_timeout = null;
    bx_page = $("#ProductThumbs").bxSlider({
      mode: 'vertical', 
      infiniteLoop: false,
      pager:false,
      slideWidth: 105,
      minSlides: 4,
      maxSlides: 4,   
      slideMargin: 10,
      onSlideBefore:function($slideElement, oldIndex, newIndex){
        clearTimeout(bxx_timeout);
        if(!isNaN(oldIndex) || !isNaN(newIndex)){
          bxx_timeout = setTimeout(function(){
            bx_slider.reloadSlider();
          },2000);

          return;

        }
      },
      onSlideAfter:function($slideElement, oldIndex, newIndex){
        clearTimeout(bxx_timeout);
        if(!isNaN(oldIndex) || !isNaN(newIndex)){
          bxx_timeout = setTimeout(function(){   
            bx_slider.reloadSlider();
          },2000);

          return;

        }
      }
    });

    $(".bxslider-home").each(function(index, el) {
      $("#bxslider-home" + index).bxSlider({
        pagerCustom: '#bx-pager-home' + index,


      });
    });
    $(".ProductThumbs-home").each(function(index, el) {
      $("#ProductThumbs-home" + index).bxSlider({
        slideWidth: 84,
        slideMargin: 12,
        minSlides: 4,
        maxSlides: 4,
        mode: 'horizontal',
        // pager: false,
        speed: 500,
        pause: 3000
      });
    });

    /**
         *  elevateZoom Zoom
         */
    $(".bxslider li:nth-of-type(2) img").elevateZoom(zoom_config);

    /**
         * Quick view modal
         */
    $(document).on('click', ".quick-view", function(event){
      event.preventDefault();
      /* Act on the event */
      $("#loading").show(400);
      var url = $(this).attr('href');
      $("#quick-view-modal .modal-content").load(url + " #product-single", function() {
        $("#quick-view-modal").modal('show');
        var html = "";
        html = html + "<span class='adding'></span><span class='added'></span><span id='AddToCartText'>Add to Cart</span>";
        $("#quick-view-modal #AddToCart").html(html);
        setTimeout(function() {
          bx_slider = $('.bxslider').bxSlider({
            pagerCustom: '#bx-pager',
            controls:false,
            onSlideBefore: function($slideElement, oldIndex, newIndex) {},
            onSlideAfter: function($slideElement, oldIndex, newIndex) {
             }
          });
          
          var price 	=	$("#ProductPrice .money").text();
          price 		=	price.substr(1,price.length);
          var number_price = parseInt(price)*100;
          
           $("#ProductPrice").empty();  
          var str =	"";
          str+= "<span class='money'>"+convert_currency(number_price)+"</span>";
          $("#ProductPrice").append(str);         
          
          
          bx_page = $("#quick-view-modal #ProductThumbs").bxSlider({
            slideWidth: 84,
            slideMargin: 12,
            minSlides: 4,
            maxSlides: 4,
            mode: 'horizontal',
            pager: false,
            speed: 500,
            pause: 3000
          });
          //  $("#quick-view-modal .bxslider li:nth-of-type(2) img").elevateZoom(zoom_config);
          $("#loading").hide(600);
        }, 200);
      });
    });
    /**
         * End quickview
         */
    /** Function display list all product in cart */

    $(document).on('click',".add-to-cart", function(event) {
      $(this).attr('disabled','disabled');
      var $this = $(this);
      $("#quick-view-modal #AddToCart span.added").css({'z-index': '0'});
      $("#quick-view-modal #AddToCart span.adding").css({'opacity':'1','z-index':'1'}).addClass('fa-2x fa fa-spinner fa-pulse');
      
      $(".pro-add-to-cart .adding-cart").css({'opacity':'1','z-index':'1','font-size':'12px'}).addClass('fa-2x fa fa-spinner fa-pulse');
      $(this).css({'opacity':'.5'});
      event.preventDefault();
      var id= parseInt($("#productSelect").val());
      var quanlity =  parseInt($("#Quantity").val());
      var $size = $("#productSelect option").length;
      if(isNaN(quanlity) || isNaN(id)){
        id =    $(this).data('pid');
        quanlity = 1;
      }
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: {
          quantity: quanlity,
          id: id
        },     

        success: function(response) {
          show_dropdown_cart();
          $('.add-to-cart').removeAttr("disabled");

          $(".pro-add-to-cart .adding-cart").removeClass('fa-2x fa fa-spinner fa-pulse');          
          $this.addClass('added-cart');
          
          $('.add-to-cart').removeAttr("disabled");
          $("#quick-view-modal #AddToCart span.adding").removeClass('fa fa-spinner fa-pulse fa-2x');
          $("#quick-view-modal #AddToCart span.added").css({'z-index': '-1'}).addClass('fa fa-check');

          $(".add-to-cart").css({'opacity':'1'});
          
          $("#modal-cart").show('slow');
          $("#modal-added-image-cart img").attr('src',response.image);
          $("#modal-added-title-cart").text(response.title);
          var my_currency = Currency.moneyFormats.USD;
          $("#modal-new-price").html(convert_currency(response.price));
          
         
        }
      });
    });


    $(document).on('click',".small-cart-remove",function(event){
      event.preventDefault();
      var id = $(this).data('id');

      $.ajax({
        url:'/cart/update.js',
        type: 'POST', 
        dataType: 'json',
        data:"updates["+id+"]=0",
        success: function(data) {
          $("#cartCost").text(convert_currency(data.total_price));
          $("#cartCount").text(data.item_count);
          $("[data-pid='"+id+"']").removeClass('added-cart');
          show_dropdown_cart();
        }
      });
      $("#item-"+id).remove();

    });

    $("#quick-view-modal button.close, #AddToCart").on('click', function(){
      $('#modal-cart').remove();
    });


    $("#addtocart-message").hide('slow');
    $("#AddToCart").on('click', function(event) {

      event.preventDefault();

      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: {
          quantity: 1,
          id: $(this).data('pid')
        },     

        success: function(response) {
          $("#addtocart-message").show('slow');
          $("#title-addtocart").text(response.title);
        }
      });
    });

    /** Function display list all product in cart */
    function show_cart() {
      $.ajax({
        url: ' /cart.js',
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          if (data.item_count > 0) {
            var html = '';
            $.each(data.items, function(index, el) {
              html = html + '<li> <h3 class="cart-title"> ' + el.title + '  </h3><div class="cart-image">';
              html = html + ' <img src="' + el.image + '" width="50" /> </div> <div class="product-infor">';
              html = html + ' <p> Price <strong> ' + el.price + ' </strong> </p>';
              html = html + ' <p> Quantity <strong> ' + el.quantity + ' </strong> </p></div>';
            });

            $("#quick-view-modal").modal('show');

            $("#quick-view-modal .modal-content").html(html);
            // swal({   title: "Your cart <i class=\"fa fa-opencart\"></i>",   text: html,   html: true,imageUrl: "//cdn.shopify.com/s/files/1/1124/4246/t/11/assets/cart.png?1591435866330862847" });
          } else {
            sweetAlert("Oops...", "Cart is empty!", "error");
          }
        }
      });
    }

    /**
         * 
         * Countdown time
         */
    $(".timmer-event").each(function() {
      var event_time = $(this).data('datetime');
      $(this).countdown(event_time, function(event) {
        var $this = $(this).html(event.strftime('' + '<span class="weeks">%w</span> weeks ' + '<span class="days">%d</span> days ' + '<span class="hours">%H</span> hr ' + '<span class="mins">%M</span> min ' + '<span class="secs">%S</span> sec'));
      });
    });
    $("#close-cart").on('click',function(){
      $("#modal-cart").hide('slow');
    });

    //Category view mode
    $('.view-mode').each(function() {
      $(this).find('.grid').on('click', function(event) {
        event.preventDefault();

        $('.view-mode').find('.grid').addClass('active');
        $('.view-mode').find('.list').removeClass('active');

        $('.shop-products').removeClass('list-view');
        $('.shop-products').addClass('grid-view');

        $('.list-col4').removeClass('col-xs-12 col-sm-4');
        $('.list-col8').removeClass('col-xs-12 col-sm-8');
      });
      $(this).find('.list').on('click', function(event) {
        event.preventDefault();

        $('.view-mode').find('.list').addClass('active');
        $('.view-mode').find('.grid').removeClass('active');

        $('.shop-products').addClass('list-view');
        $('.shop-products').removeClass('grid-view');

        $('.list-col4').addClass('col-xs-12 col-sm-4');
        $('.list-col8').addClass('col-xs-12 col-sm-8');
      });
    });

    $('[data-toggle=\'tooltip\']').tooltip({
      container: 'body'
    });
    $(".close").on('click',function(){
      $(".zoomContainer").remove();
    });

    $('audio,video').mediaelementplayer({audioWidth: '100%', enableAutosize: true});
    $('.flexslider').flexslider(); 
    $(".slider-shortcode").nivoSlider({ 
      effect: 'random'

    });


    if (!$.isEmptyObject(compare)) {
      $(".error-compare").hide(20);
      var list_id = '';
      var json_compare = [];
      var check_end = 0;
      var compare_size = (Object.keys(compare).length - 1);
      $.each(compare, function(index, el) {
        $("[data-pid='"+el+"']").addClass('added').text('Added to compare');
        var json_url = "/products/" + el + ".js";
        if ($.trim(el) != "") {
          jQuery.getJSON(json_url, function(product) {
            json_compare[check_end] = product;
            if (check_end >= compare_size) {
              compare_to_table(json_compare);
            }
            check_end += 1;
          });

        }

      });
    } else {
      $(".error-compare").show();
    }
	    
     $(document).on("click","[id^='count_']", function(event) {      
      event.preventDefault();
      var id = $(this).attr('id');
//         $(".listproduct").hide(); 
       	$(".shop-products .listproduct").addClass('hide'); 
        $(".page_"+id).removeClass('hide');

          $(".pagination li").removeClass("active");
            $(this).parent().addClass("active");

        var num = parseInt($(this).text()) ;
        console.log(num);

        $('html, body').animate({scrollTop: 0}, 800);            

    });

  });
})(jQuery);